export const CMD_TYPES = {
  requestTermsList: 10020,
  requestTermsDetail: 10021,
  requestSendCertNumber: 10013,
  requestJoin: 10014,
  requestPartnerList: 10015,
  CheckMvnoMember: 10016,
  CheckVulnerable: 10018,
} as const
